import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './context/AuthContextZustand';
import { ChatProvider } from './context/ChatContext';
import { ToastProvider } from './components/UI';
import { CookieConsentBanner } from './components/layout/CookieConsentBanner';
import ScrollToTop from './components/layout/ScrollToTop';
import AppRoutes from './routes/AppRoutes';

function App() {
  return (
    <ToastProvider>
      <AuthProvider>
        <ChatProvider>
          <Router>
            <ScrollToTop />
            <AppRoutes />
            <CookieConsentBanner />
          </Router>
        </ChatProvider>
      </AuthProvider>
    </ToastProvider>
  );
}

export default App;
